// extracted by mini-css-extract-plugin
export var group = "MainNavigation-module--group--37919";
export var layout = "MainNavigation-module--layout--d6ed2";
export var link = "MainNavigation-module--link--2f61f";
export var menu = "MainNavigation-module--menu--f1cad";
export var navigation = "MainNavigation-module--navigation--e2c4e";
export var submenu = "MainNavigation-module--submenu--6aa79";